/**
 * Vantage sensor type constants and utilities
 */

const VANTAGE_SENSOR_TYPES = {
  COLOR: 1,
  TEMP_HUMIDITY: 2,
  INTRUSION: 4,
  COMMON: 5,
};

/**
 * Get the translated sensor type name
 * @param {number} sensorType - The sensor type number
 * @param {function} t - Translation function
 * @returns {string} Translated sensor type name
 */
export function getSensorTypeName(sensorType, t) {
  switch (sensorType) {
    case VANTAGE_SENSOR_TYPES.COLOR:
      return t('sensors.types.colorSensor');
    case VANTAGE_SENSOR_TYPES.TEMP_HUMIDITY:
      return t('sensors.types.tempHumiditySensor');
    case VANTAGE_SENSOR_TYPES.INTRUSION:
      return t('sensors.types.intrusionSensor');
    case VANTAGE_SENSOR_TYPES.COMMON:
      return t('sensors.types.common');
    default:
      return t('sensors.types.unknownSensorType');
  }
}
